import useClientQuery from "../../../../global/queries/useClientQuery";
import {AccordionData} from "../../../../global/interfaces/AccordionData";
import ABKAccordion from "../../../../global/components/ABKAccordionAlt";


const CompanyDataAccordion = () => {

    const {data: client} = useClientQuery();

    const companyData: AccordionData[] = [
        {label: "Name", size: 6, value: client?.name1},
        {label: "Telefon", size: 6, value: client?.telefon1},
        {label: "Name (Zeile 2)", size: 6, value: client?.name2},
        {label: "E-Mail", size: 6, value: client?.email},
        {label: "Webseite", size: 6, value: client?.web},
        {label: "E-Mail (e-Rechnungen)", size: 6, value: client?.emailERechnung},
        {label: "Straße, Nr.", size: 6, value: `${client?.strasse}`},
        {label: "Land | PLZ | Ort", size: 6, value: `${client?.land}-${client?.plz} | ${client?.ort}`},
        {label: "UID-Nummer", size: 6, value: client?.uidnr},
        {label: "Firmenbuchnummer", size: 6, value: client?.firmenbuchnummer}
    ]


    return <ABKAccordion isInput={false} accordionTitle={"Firmendaten"} data={companyData} />
}

export default CompanyDataAccordion;